import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=c6ad2634&"
import script from "./formItem.vue?vue&type=script&lang=js&"
export * from "./formItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports